<template>
    <div class="backpage" @click="goBack">
        <!-- <el-icon>
            <Back />
        </el-icon> -->
        ← 返回上一级
    </div>
    <div class="installt">
        <div class="intext">商品发布</div>





    </div>
    <div class="leix">
        <div class="leitop">选择品类</div>
        <div class="fenleichuan">
            <div class="fenleichuans" :class="istore ==1 ? 'fenleichuanson' : ''" @click="fenleis(1)">助花商品</div>
            <div class="fenleichuans" :class="istore ==2 ? 'fenleichuanson' : ''" @click="fenleis(2)">积分商品</div>
            <div class="fenleichuans" :class="istore ==3 ? 'fenleichuanson' : ''" @click="fenleis(3)">零元购</div>
        </div>
        <div class="leifrom">
            <div class="leichoose">
                <div class="leiinp">
                    <input placeholder="请输入一级类型" v-model="tanme" @input="filterItems">
                </div>
                <div class="leival">
                    <div v-for="(item, index) in filteredList">
                        <div class="tname" @click="tname(item.tid, item.tname)">
                            {{ item.tname }}
                        </div>
                    </div>

                </div>
            </div>
            <div class="leichoose">
                <div class="leiinp">
                    <input type="text" placeholder="请输入二级类型" v-model="tanme2">
                </div>
                <div class="leival">
                    <div v-for="(item, index) in listarr2">
                        <div class="tname" @click="tname2(item.tid, item.tname)">
                            {{ item.tname }}
                        </div>
                    </div>

                </div>
            </div>
            <div class="leichoose">
                <div class="leiinp">
                    <input type="text" placeholder="请输入三级类型" v-model="tanme3">
                </div>
                <div class="leival">
                    <div v-for="(item, index) in listarr3">
                        <div class="tname" @click="tname3(item.tid, item.tname)">
                            {{ item.tname }}
                        </div>
                    </div>

                </div>
            </div>
        </div>
        <div class="leilianxi">
            如果要添加类目与品牌请联系我们！
        </div>
        <div class="nextpage">
            <div class="nextpages" @click="goadd()">
                选好类型了，下一步
            </div>

        </div>
    </div>

</template>

<script setup>
import api from '@/api/api'
import { onMounted, ref, computed } from 'vue';
import { useRouter } from 'vue-router';
import { ElMessage } from 'element-plus'
const router = useRouter()
onMounted(() => {
    productCategory(1)
})
let istore = ref(1)
let listarr = ref([])
let listarr2 = ref([])
let listarr3 = ref([])

let tanme = ref(null)
let tanme2 = ref(null)
let tanme3 = ref(null)
let tid = ref(null)
let tid2 = ref(null)
let tid3 = ref(null)
const filteredList = computed(() => {
    return listarr.value.filter(item => {
        if (item.tname && tanme.value) {
            return item.tname.toLowerCase().includes(tanme.value.toLowerCase());
        } else {
            return listarr.value
        }
    });
});
const fenleis = (isstore) => {

    if (isstore == istore.value) {

    } else {
        listarr.value = []
        listarr2.value = []
        listarr3.value = []

        tanme.value = null
        tanme2.value = null
        tanme3.value = null
        tid.value = null
        tid2.value = null
        tid3.value = null
        istore.value = isstore
        if (isstore ==1 || isstore ==3 ) {
            productCategory(1)
        } else {
            productCategory(2)
        }
    }

}
const tname = (id, name) => {
    tid.value = id
    tanme.value = name
    // listarr2.value =  listarr.value.filter( val =>  val.tid == id )
    for (let a = 0; a < listarr.value.length; a++) {
        if (listarr.value[a].tid == id) {
            listarr2.value = listarr.value[a].children
        }
    }
    listarr3.value = []
    tanme3.value = null
    tanme2.value = null

    console.log(listarr2.value)
}
const tname2 = (id, name) => {
    tanme2.value = name
    tid2.value = id
    for (let a = 0; a < listarr2.value.length; a++) {
        if (listarr2.value[a].tid == id) {
            listarr3.value = listarr2.value[a].children
        }
    }
    console.log(listarr3.value)
    tanme3.value = null


}
const tname3 = (id, name) => {
    tanme3.value = name
    tid3.value = id


}
const productCategory = async (nub) => {

    const res = await api.productCategory(nub)
    console.log(res)
    if (nub == 2) {
        listarr.value = res.data.map(item => {
            return {
                tname: item.name,
                tid: item.id,
                children: item.children,
                tpid: item.pid
            };
        });
    } else {
        listarr.value = res.data

    }


}
const goBack = () => {
    window.history.back();
}
const goadd = () => {
    let nub = istore.value

    if (tid.value == null) {
        ElMessage({
            message: '至少选中一级一个一级分类！',
            type: 'warning',
        })
    } else {
        const tanmes = [tanme.value, tanme2.value, tanme3.value]
        const tids = [tid.value, tid2.value, tid3.value]
        router.push({
            path: '/home/goodlist/goodadd',
            query: {
                tanme: tanmes,
                tid: tids,
                pubilsh: nub
            }
        })
    }

    // console.log()

}
</script>

<style lang="scss" scoped>
input {
    margin: 0;
    // padding: 0;
    box-sizing: border-box;
}

.backpage {
    margin-top: -20px;
    font-size: 16px;
    color: #3F8CFF;
    cursor: pointer;
}

.installt {
    width: 1164px;
    display: flex;
    height: 52px;
    justify-content: space-between;
    align-items: center;

    .intext {
        font-size: 36px;
        font-weight: 400;
        color: #0A1629;
    }



}

.leix {
    width: 100%;
    height: calc(100% - 75px);
    background-color: #fff;
    margin-top: 11px;
    padding: 20px 0 0 11px;
    box-sizing: border-box;

    .leitop {
        font-weight: 400;
        font-size: 20px;
        color: rgba(0, 0, 0, 0.85);
        margin-left: 15px;
    }

    .fenleichuan {
        margin-top: 10px;
        display: flex;

        .fenleichuans {
            width: 132px;
            height: 48px;
            box-shadow: 0px 6px 12px 0px rgba(63, 140, 255, 0.26);
            text-align: center;
            line-height: 48px;
            margin-right: 20px;
            border-radius: 8px;
            font-weight: 400;
            font-size: 16px;

            cursor: pointer;
            color: #3F8CFF;
            background: #FFFFFF;

        }

        .fenleichuanson {
            color: #FFFFFF;
            background: #3F8CFF;
        }

    }

    .leifrom {
        width: 85%;
        height: 500px;
        margin-top: 15px;
        border: 1px solid #ECECEC;
        display: flex;

        .leichoose {
            width: 239px;
            height: 100%;
            background-color: #dee1e9;
            border: 1px solid #ECECEC;
            box-sizing: border-box;

            .leiinp {
                width: 222px;
                height: 32px;
                margin: 16px 0 0 12px;

                input {

                    width: 100%;
                    height: 100%;

                    background-color: #fff;
                }
            }

            .leival {
                width: 100%;
                height: calc(100% - 17px - 32px - 16px);
                overflow: auto;
                margin-top: 17px;
                background-color: #fcfcfc;
                padding-left: 12px;
                box-sizing: border-box;

                .tname {
                    font-weight: 400;
                    font-size: 14px;
                    color: #2A2A2A;
                    line-height: 30px;
                    cursor: pointer;
                }
            }
        }
    }

    .leilianxi {
        font-size: 13px;
        color: #666666;
        margin-top: 20px;
    }

    .nextpage {
        width: 400px;
        // width: 100%;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;

        color: #F4F5F6;

        .nextpages {
            width: 191px;
            height: 44px;
            background: #2851C0;
            border-radius: 32px;
            border: 1px solid #707070;
            text-align: center;
            line-height: 44px;
            font-weight: 400;
            font-size: 14px;
        }
    }
}
</style>